const splide = new Splide('.splide', {
    type:"loop",
    perPage: 3,
    perMove: 1,
    autoWidth: true,
    pagination:false,
    speed:500,
    drag:false,
    breakpoints: {
        1024: {
            perPage: 1,
            pagination:true,
            autoWidth: true,
            drag:true,
            arrows:false,
        }
    },
} );

splide.mount();

// slide.on("moved",() => {
//    const activeElement =  document.getElementsByClassName("is-active")
//
//     activeElement.classList.remove("is-active")
//     activeElement.classList.add("is-active")
// })


